<template>
  <div class="register-container">
    <div class="register-main">
      <div class="login-header">
        <a href="http://www.spr-atm.com">
          <img src="@images/logo2.png" />
        </a>
        <div class="login">注册</div>
      </div>
      <el-card class="register-left">
        <div class="title-wrapper">
          <div class="title-zh">
            我们的服务
          </div>
          <div class="title-en">
            Our services
          </div>
        </div>
        <ul class="function-wrapper">
          <li>传统采购</li>
          <li>委托采购</li>
          <li>需求查询</li>
          <li>产品推荐</li>
        </ul>
      </el-card>
      <el-card class="register-right">
        <div class="top">
          <img src="@images/cooperation_lib_logo.png"
               alt="合作库-供应商查询系统">
          <div class="title">
            合作库-供应商查询系统
          </div>
        </div>

        <el-form :model="registerForm"
                 :rules="registerRules"
                 status-icon
                 ref="registerFormRef">
          
          <el-form-item prop="userName">
            <el-input placeholder="用户名"
                      size="mini"
                      v-model="registerForm.userName"
                      prefix-icon="iconfont icon-user">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input placeholder="密码"
                      size="mini"
                      type="password"
                      v-model="registerForm.password"
                      show-password
                      prefix-icon="iconfont icon-password">
            </el-input>
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input placeholder="确认密码"
                      size="mini"
                      type="password"
                      show-password
                      v-model="registerForm.confirmPassword"
                      prefix-icon="iconfont icon-password">
            </el-input>
          </el-form-item>


          <el-form-item prop="accountName">
            <el-input placeholder="姓名或企业名称"
                      size="mini"
                      v-model="registerForm.accountName"
                      prefix-icon="iconfont icon-user">
            </el-input>
          </el-form-item>
          <el-form-item prop="accountDescribe">
            <el-input placeholder="可供应产品"
                      size="mini"
                      v-model="registerForm.accountDescribe"
                      prefix-icon="iconfont icon-product">
            </el-input>
          </el-form-item>
          <el-form-item prop="qq">
            <el-input placeholder="请输入QQ号"
                      size="mini"
                      v-model="registerForm.qq"
                      prefix-icon="iconfont icon-QQ">
            </el-input>
          </el-form-item>
          <el-form-item prop="emailAddress">
            <el-input class="email"
                      placeholder="请输入邮箱"
                      size="mini"
                      type="email"
                      v-model="registerForm.emailAddress"
                      prefix-icon="iconfont icon-email">
            </el-input>
          </el-form-item>
          <el-form-item prop="phoneNumber">
            <div class="phone-tips">请验证手机号：</div>
            <el-input placeholder="手机号码"
                      size="mini"
                      v-model="registerForm.phoneNumber"
                      prefix-icon="iconfont icon-phone">
            </el-input>
          </el-form-item>
          <el-form-item prop="phoneCode"
                        class="code-wrapper">
            <el-input placeholder="短信验证码"
                      size="mini"
                      v-model="registerForm.phoneCode"
                      prefix-icon="iconfont icon-duanxin">
            </el-input>
            <div :class="[{'is-unusable': isCodeBtnUnusable},'get-code']"
                 v-if="!isSentCode"
                 @click="showVerifyDialog">获取验证码</div>
            <div class="regain-code"
                 v-if="isSentCode">重新获取({{countDown}})</div>
          </el-form-item>
        </el-form>
        <div class="register-btn"
             @click="submitRegisterForm">
          提交申请
        </div>
        <div class="btn-wrapper">
          <router-link to="/login"
                       class="supplier-login-btn">
            供应商登录
          </router-link>
          <router-link to="/user-login"
                       class="user-register-btn">
            客户登录
          </router-link>
        </div>
      </el-card>
    </div>
    <div class="register-footer">
      Copyright &copy; 2019-2026 深圳市森普瑞科技 版权所有
      <!-- <cnzz /> -->
    </div>
    <el-dialog :visible.sync="verifyDialogVisible"
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :destroy-on-close="true"
               class="verify-dialog"
               top="300px"
               width="300px">
      <div slot="title"
           class="header">
        <span>向右拖动完成验证</span>
        <div class="close"
             @click="verifyDialogVisible = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <slide-validation @verifySuccess="verifySuccess" />
    </el-dialog>
    <el-dialog :visible.sync="applyDialogVisible"
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :destroy-on-close="true"
               class="apply-dialog"
               top="300px"
               width="340px">
      <div slot="title"
           class="header">
        <span>申请成功</span>
      </div>
      <div>客服人员会在24小时内与您联系，请耐心等待！</div>
      <div slot="footer">
        <el-button type="primary"
                   size="mini"
                   @click="applyConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import slideValidation from '@/components/public/slideValidation'
import qs from 'qs'
// import CNZZ from '@/components/public/CNZZ.vue'
export default {
  components: {
    'slide-validation': slideValidation,
    // cnzz: CNZZ
  },
  data () {
    var validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认密码'));
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    let validatePhone = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('请输入手机号'));
      } else {
        let reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          this.isCodeBtnUnusable = false
          callback();
        }
      }
    };
    let validateCode = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('请输入验证码'));
      }
      else if (!this.codeVerify) {
        callback(new Error('验证码不正确'));
      }
      callback()
    }
    return {
      registerForm: {
        userName: '',
        password: '',
        confirmPassword:'',
        accountName: '',
        accountDescribe: '',
        qq: '',
        emailAddress: '',
        phoneNumber: '',
        phoneCode: ''
      },
      registerRules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,30}$/, message: '用户名必须包含数字和字母，且在8-30位', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/, message: '密码必须包含数字和字母，且在8-16位', trigger: 'blur' },
        ],
        confirmPassword: [
            { required: true, message: '请确认密码', trigger: 'blur' },
            { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/, message: '密码必须包含数字和字母，且在8-16位', trigger: 'blur' },
            { validator: validateConfirmPass, trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: '请输入姓名或企业名称', trigger: 'blur' },
        ],
        accountDescribe: [
          { required: true, message: '请输入可供应产品', trigger: 'blur' },
        ],
        qq: [
          { required: true, message: '请输入QQ号', trigger: 'blur' },
          { pattern: /^[1-9][0-9]{4,9}$/, message: '请输入正确的QQ号', trigger: 'blur' }
        ],
        emailAddress: [
          { pattern: /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/, message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        phoneNumber: [
          { validator: validatePhone, trigger: ['blur', 'change'] },
        ],
        phoneCode: [
          // { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^[0-9]{6}$/, message: '请输入正确的验证码', trigger: 'blur' },
          { validator: validateCode, trigger: 'blur' },
        ]
      },
      verifyDialogVisible: false,
      isSentCode: false,
      countDown: 60,
      timer: 0,
      isCodeBtnUnusable: true,
      codeVerify: true,
      applyDialogVisible: false
    };
  },
  created () {

  },
  mounted () {

  },
  watch: {
    countDown (newval) {
      if (newval < 1) {
        clearInterval(this.timer)
        this.isSentCode = false
        this.countDown = 60
      }
    }
  },
  methods: {
    showVerifyDialog () {
      if (this.isCodeBtnUnusable) {
        return
      } else {
        this.verifyDialogVisible = true
      }
    },
    getCode () {
      let phoneNumber = this.registerForm.phoneNumber
      this.$http.post('/api/services/inquiryApp/account/RegisterSmsSender', { phoneNumber })
        .then(res => {
          if (res.success) {
            this.isSentCode = true
            let timer = setInterval(() => {
              this.countDown--
            }, 1000);
          }
        })
        .catch(err => {
          this.$message.error(err.data.error.message)
        })
    },
    verifySuccess () {
      this.verifyDialogVisible = false
      this.getCode()
    },
    submitRegisterForm () {
      this.$refs.registerFormRef.validate((valid) => {
        if (valid) {
          this.$http.post('/api/services/inquiryApp/account/Create', this.registerForm)
            .then(res => {
              if (res) {
                this.applyDialogVisible = true
              }
            })
            .catch(err => {
              if (!err.response.data.success) {
                this.codeVerify = false
                this.$refs.registerFormRef.validateField('phoneCode')
              } else {
                this.$message.error(err.response.error.message)
              }
            })
        } else {
          console.log('error submit!!')
          return false;
        }
      })
    },
    applyConfirm () {
      this.applyDialogVisible = false
      window.location.href = 'http://www.spr-atm.com'
    }
  }
}
</script>
<style lang="less" scoped>
.register-container {
  height: 100%;
  min-height: 748px;
  position: relative;
  font-family: 'Source Han Sans CN';
  background: url('../assets/images/login_bg1.jpg') no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}
.register-main {
  width: 860px;
  height: 700px;
  position: relative;
}
.login-header {
  height: 50px;
  position: absolute;
  left: 0;
  top: -80px;
  display: flex;
  align-items: center;
  a {
    height: 100%;
    margin-right: 20px;
    cursor: pointer;
    img {
      height: 100%;
    }
  }
  .login {
    height: 100%;
    line-height: 50px;
    padding-left: 20px;
    border-left: 1px solid #e3ecf8;
    font-size: 25px;
    color: #f6f9fd;
  }
}
.register-left {
  background: url('../assets/images/login_bg2.jpg') no-repeat;
  width: 448px;
  height: 690px;
  box-shadow: 0px 16px 25px rgba(76, 99, 211, 0.54) !important;
  border-radius: 10px;
  border: none;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: 300;
  z-index: 5;
  /deep/ .el-card__body {
    width: 100%;
    height: 100%;
    padding: 0;
  }
  .title-wrapper {
    position: absolute;
    left: 30px;
    top: 40px;
    text-align: right;
    .title-zh {
      font-size: 28px;
      color: #ffffff;
      opacity: 0.9;
      padding-bottom: 15px;
      position: relative;
      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        right: 0;
        width: 40%;
        height: 1px;
        background: #ffffff;
      }
    }
    .title-en {
      margin-top: 10px;
      font-size: 12px;
      color: #ffffff;
      opacity: 0.5;
    }
  }
}
.function-wrapper {
  position: absolute;
  left: 56px;
  top: 140px;
  list-style: disc;
  li {
    list-style: disc;
    color: #ffffff;
    opacity: 0.8;
    font-size: 16px;
    margin-top: 24px;
    &:nth-child(2) {
      margin-left: 12px;
      opacity: 0.7;
    }
    &:nth-child(3) {
      margin-left: 24px;
      opacity: 0.6;
    }
    &:nth-child(4) {
      margin-left: 36px;
      opacity: 0.5;
    }
  }
}
.register-right {
  background-color: #ffffff;
  width: 420px;
  height: 650px;
  box-shadow: 0px 16px 20px rgba(76, 99, 211, 0.3);
  border-radius: 10px;
  position: absolute;
  right: 0;
  top: 20px;
  padding: 30px 60px 20px 68px;
  /deep/ .el-card__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .top {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 35px;
      height: 35px;
      margin-right: 10px;
    }
    .title {
      font-size: 20px;
      font-weight: 300;
      color: #4a62d0;
    }
  }
}
.el-form {
  width: 100%;
  margin-top: 20px;
  .el-form-item {
    width: 100%;
    margin-bottom: 15px;
    border-bottom: 1px solid #99b9f2;
    /deep/ .iconfont {
      color: #99b9f2;
    }
    .phone-tips {
      line-height: 14px;
      color: #999999;
      margin-left: 5px;
    }
    .el-input {
      position: relative;
      /deep/ .el-input__inner {
        border: none;
        outline: none;
        input {
          border: none;
          outline: none;
        }
      }
      &::after {
        position: absolute;
        content: '*';
        top: -2px;
        left: -2px;
        color: #d36b75;
      }
    }
    .email {
      &::after {
        content: '';
      }
    }
    /deep/ .el-form-item__content {
      line-height: 28px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #99b9f2 !important;
    }
    /deep/ input::-moz-placeholder {
      color: #99b9f2 !important;
    }
  }
  .code-wrapper {
    /deep/ .el-form-item__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .get-code {
        font-size: 12px;
        background: linear-gradient(
          91deg,
          rgba(76, 98, 210, 1) 0%,
          rgba(125, 168, 237, 1) 100%
        );
        padding: 4px 12px;
        height: 20px;
        line-height: 12px;
        border-radius: 8px;
        white-space: nowrap;
        color: #99b9f2;
        user-select: none;
        cursor: pointer;
      }
      .is-unusable {
        color: #bbbbbb !important;
        background: #cccccc !important;
        cursor: not-allowed;
      }
      .regain-code {
        font-size: 12px;
        background: #cccccc;
        padding: 4px 12px;
        height: 20px;
        line-height: 12px;
        border-radius: 8px;
        white-space: nowrap;
        color: #ffffff;
        user-select: none;
        cursor: not-allowed;
      }
    }
  }
}
.register-btn {
  height: 40px;
  width: 100%;
  margin-top: 20px;
  background: linear-gradient(
    91deg,
    rgba(76, 98, 210, 1) 0%,
    rgba(125, 168, 237, 1) 100%
  );
  box-shadow: 0px 5px 10px rgba(76, 99, 211, 0.3);
  border-radius: 10px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #ffffff;
  user-select: none;
  cursor: pointer;
}
.btn-wrapper {
  width: 100%;
  height: 40px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .supplier-login-btn,
  .user-register-btn {
    width: 140px;
    height: 40px;
    border: 1px solid #99b9f2;
    border-radius: 8px;
    text-align: center;
    color: #7da8ed;
    line-height: 40px;
    cursor: pointer;
    user-select: none;
    &:hover {
      background-color: #f5f5f5;
      color: #5670d7;
    }
  }
}
.register-footer {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 16px;
  color: #ffffff;
}
.verify-dialog {
  /deep/ .el-dialog__header {
    padding: 0 10px !important;
    height: 30px;
    line-height: 30px;
    color: #b10000;
    background-color: #e5e5e5;
  }
  /deep/ .el-dialog__body {
    padding-bottom: 60px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .close {
      width: 20px;
      height: 20px;
      background-color: #d03434;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        font-size: 16px;
        color: #ffffff;
      }
    }
  }
}
.apply-dialog {
  /deep/ .el-dialog__header {
    padding: 0 10px !important;
    height: 30px;
    line-height: 30px;
    color: #b10000;
    background-color: #e5e5e5;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>